export const VIATOR_AFFILIATE_PARAMS = {
  mcid: '54929',
  sv1: 'affiliate',
  sv_campaign_id: '1706061',
  awin_plat_id: '11018',
  awc: '11018_1760962558_61632f22409ec8d59ff0723ff107989e',
  aid: 'awinUSDEEPLINK_1706061',
  gad_source: '1'
};

function hostName(url) {
  const match = String(url || '').match(/^https?:\/\/([^/?#]+)/i);
  return String(match?.[1] || '').replace(/^www\./i, '').toLowerCase();
}

function mergeQuery(url, extra) {
  const [withoutHash, hash] = String(url || '').split('#');
  const [base, existing = ''] = withoutHash.split('?');
  const params = new URLSearchParams(existing);
  Object.entries(extra).forEach(([key, value]) => {
    params.set(key, value);
  });
  const query = params.toString();
  return `${base}${query ? `?${query}` : ''}${hash ? `#${hash}` : ''}`;
}

export function withViatorAffiliate(url) {
  if (!/(^|\.)viator\.com$/i.test(hostName(url))) return url;
  return mergeQuery(url, VIATOR_AFFILIATE_PARAMS);
}

export function viatorSearchUrl(query) {
  const text = String(query || '').trim();
  if (!text) return '';
  return mergeQuery('https://www.viator.com/searchResults/all', {
    text,
    ...VIATOR_AFFILIATE_PARAMS
  });
}

export function bookingSearchUrl(query) {
  const ss = String(query || '').trim();
  if (!ss) return '';
  const params = new URLSearchParams({
    ss,
    utm_source: 'dejavu-nomad',
    utm_medium: 'affiliate',
    utm_campaign: 'ai-suggestions'
  });
  return `https://www.booking.com/searchresults.html?${params.toString()}`;
}
